// 神策数据埋点
import sensors from "sa-sdk-javascript";

sensors.registerPage({
    // h5
    client_type: 4
});

let server_url = "";

if (import.meta.env.DEV) {
    server_url = "http://localhost:8848/dataService/tracking-point/sensors/collect";
} else {
    server_url = new URL(import.meta.env.VITE_API_URL).origin + "/dataService/tracking-point/sensors/collect";
}

sensors.init({
    server_url,
    is_track_single_page: false, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    use_client_time: true,
    send_type: "beacon",
    heatmap: {
        //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
        clickmap: "not_collect",
        //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
        scroll_notice_map: "not_collect"
    },
    show_log: true
});
